export default __webpack_public_path__ + "static/media/image_left.41cd0df7.svg";